import React from 'react';
import type { RefObject } from 'react';

import type { PosItem } from '../../api/usePosItemsSearch';
import type { PosSaleLine } from '../../types';
import { PosItemSearch } from '../PosItemSearch';

export interface PosCatalogSectionProps {
  inputRef: RefObject<HTMLInputElement | null>;
  customerId: number | null;
  subscriptionsEnabled: boolean;
  onSelectItem: (item: PosItem) => void;
  cartLines: PosSaleLine[];
  onQuantityChange: (lineKey: string, quantity: number) => void;
  onRemoveLine: (lineKey: string) => void;
}

export const PosCatalogSection: React.FC<PosCatalogSectionProps> = ({
  inputRef,
  customerId,
  subscriptionsEnabled,
  onSelectItem,
  cartLines,
  onQuantityChange,
  onRemoveLine,
}) => (
  <PosItemSearch
    inputRef={inputRef}
    onSelectItem={onSelectItem}
    cartLines={cartLines}
    onQuantityChange={onQuantityChange}
    onRemoveLine={onRemoveLine}
    customerId={subscriptionsEnabled ? customerId : null}
    showTypeFilter
    defaultItemType="product"
    selectionRetentionMs={5000}
    behaviorContext={{
      appArea: 'erp',
      feature: 'pos',
      surface: 'fullscreen',
      entryPoint: 'sales_screen',
      componentId: 'item_search',
    }}
  />
);

export default PosCatalogSection;
